<template>
  <div class="mw-split-container mw-bar-data">
    <split-pane :defaultPercent="30" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">


    <mw-dialog   ref="titleTree" :title=" addCode ? '新建' : '编辑' " size="large_large"
      :before-close="handleClose" :close-on-click-modal="false">

      <div class="mw-toolbar">
        <el-button  type="primary" @click="handleClose"> <i class="fa fa-mail-reply "></i>  关闭</el-button>
        <el-button  type="primary" @click="saveDict"> <i class="fa fa-file-text"></i>  保存</el-button>
      </div>

      <div class="mw-toolbar__body" >
        <el-form :model="form" label-width="130px" :rules="formRules" ref="dataForm" style="margin-top:20px;">
          <el-col :span="24">
            <el-form-item label="类别" prop="catalog">
              <el-input v-model="form.catalog"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="编码" prop="code">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否有效" prop="active">
              <el-radio-group v-model="form.active">
                <el-radio label="T">是</el-radio>
                <el-radio label="F">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否私有" prop="personal">
              <el-radio-group v-model="form.personal">
                <el-radio label="T">是</el-radio>
                <el-radio label="F">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

           <el-col :span="24" v-show="form.personal === 'T'">
              <el-form-item label="所属单位">
                <el-input v-model="form.unitName" style="width: 65%"></el-input>
                <el-button @click="showDialog('unitTree')">选择</el-button>
                <el-button @click="clearDept">清空</el-button>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-show="false">
              <el-form-item label="所属单位">
                <el-input v-model="form.unitId"></el-input>
              </el-form-item>
            </el-col>


          <el-col :span="12">
            <el-form-item label="选项值类型" prop="types">
              <el-radio-group  @change="handleRadio" v-model="form.types">
                <el-radio label="0">值</el-radio>
                <el-radio label="1">设置选项值</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="选项值" prop="value">
              <template  v-if="form.types === '1'">
                <el-button type="primary" @click="addSetting">设置选项值</el-button>
              </template>

               <template v-else>
                <el-input v-model="form.value"></el-input>
              </template>

            </el-form-item>
          </el-col>


          <el-col :span="12"  prop="values" v-show="false">
            <el-form-item label="选项值" >
              <el-input v-model="form.values" ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否开放前台编辑" >
              <el-radio-group v-model="form.typeedit">
                <el-radio :label="1">开放</el-radio>
                <el-radio :label="2">不开放</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>

        </el-form>


      </div>

    </mw-dialog>

    <mw-dialog ref="setValuesDialog" :footerButton="setButton" size="small_large" title="设置选项值">
      <dValues :dataId="form.id"  ref="valueChoose"></dValues>
    </mw-dialog>



    <first ref="unitTree" @confirm="deptChoose"></first>

    <mw-dialog title="选择修改分类" size="mini_mini" ref="editListDialog" :footerButton="editListButton">
      <!-- <div class="mw-toolbar__body" > -->
        <el-form style="margin-top:20px">
          <el-form-item label="分类">
            <el-input v-model="catalog"></el-input>
          </el-form-item>

        </el-form>
      <!-- </div> -->
    </mw-dialog>

    <mw-dialog ref="leadDialog" title="数据导入" size="mini_mini" :footerButton="leadButton">
       <div class="mw-dialog_body" style="margin-top:20px;">
          <el-form label-width="100px">
            <el-col :span="24">
              <el-form-item label="数据文件:">
                <template>
                  <el-upload ref="importDict"
                             :on-success="importSuccessFunc"
                    style="display: inline-block"
                             :auto-upload="false"
                            :action="action"
                            multiple
                            :headers="headers"
                            :limit="1">
                    <el-button>选择</el-button>
                  </el-upload>
                </template>
              </el-form-item>
            </el-col>

           <!-- <el-col :span="24">
             <el-form-item label="应用：">
               <el-select placeholder="请选择" v-model="app">
                <el-option
                  v-for="item in application"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>-->
          </el-form>
       </div>
    </mw-dialog>

        <div class="mw-toolbar">
          <el-button @click="expand" size="mini"><i class="fa fa-angle-double-down"></i>展开</el-button>
          <el-button @click="closed" size="mini"><i class="fa fa-angle-double-up"></i>折叠</el-button>
          <el-button @click="exportAll" size="mini"><i class="fa fa-external-link"></i>全部导出</el-button>
        </div>

      <div class="mw-toolbar__body">
        <mw-tree :url="dictTreeUrl" :async="false" :multiple="false" :selectFirst="true"   :expandedFirst="true"
            :dragEnable="true"     @changed="loadTableTree" ref="dictTree" :defaultParams="treeDefaultParams">
        </mw-tree>
      </div>

    </div>
  </template>
  <template slot="paneR">
    <div class="mw-split-right" >

        <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable" >
          <span slot="more">
          <el-dropdown trigger="hover" @command="handleCommand">
          <el-button class="el-dropdown-link">
            <!-- 更多<i class="el-icon-caret-bottom el-icon--right"></i> -->
            更多 <i class="fa fa-angle-double-right"></i>
          </el-button>
          <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
            <el-dropdown-item command="leadOut">导出</el-dropdown-item>
            <el-dropdown-item command="lead">导入</el-dropdown-item>
            <el-dropdown-item command="leadOldData">导入旧数据</el-dropdown-item>
            <el-dropdown-item command="loadModules">加入模块</el-dropdown-item>
            <el-dropdown-item command="loadUpdateData">加入更新包</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
          </span>
        </toolbar-table>

    </div>
  </template>
</split-pane>

  </div>
</template>
<script>
import token from "@/common/utils/token";
import first from "./user/firstDept.vue";
import dValues from "./user/dataValues.vue";
export default {
  components: {
    first,
    dValues
  },
  props: {
    params: {
      type: Object
    },
    /**
     * 是否应该在 listDictTree, listDict 和 saveDict 的参数中传 applicationId
     */
    shouldApplicationIdInRequest: {
      type: Boolean
    }
  },

  data() {
    let me = this;
    let appId=this.$route.params.appId;
    if(this.$route.params.itemId){
      appId='';
    }
    let treeDefaultParams;
    if (this.shouldApplicationIdInRequest) {
      treeDefaultParams = {
        applicationId: appId
      };
    } else {
      treeDefaultParams = {};
    }
    return {
      layout: [],
      headers: {},
      appId:appId,
      dictTreeUrl: this.mwUrl(`/api/data/listDictTree`),
      action: this.mwUrl(`/api/sys/importDict${this.shouldApplicationIdInRequest ? `?applicationId=${appId}` : ''}`),
      selectNode: "",
      catalog: "",
      addCode: true,
      more: false,
      moreSys: false,
      form: {
        catalog: "",
        name: "",
        active: "T",
        personal: "F",
        atrrs: "S",
        types: "0",
        typeedit: 2,
        values: "",
        applicationId:'',
        codeContent: '',
        remark: "",
        unitName: "",
        unitId: "",
        code: ''
      },
      keyValues:{

      },

      formRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        value: [{ required: true, message: "请输入或选择值", trigger: "blur" }]
      },

      setButton: [
        {
          label: "确定",
          func: this.chooseSure
        },
        {
          label: "取消",
          type: "default",
          func: this.cancel
        }
      ],

      editListButton: [
        {
          label: "确定",
          func: this.editListSure
        },
        {
          label: "取消",
          type: "default",
          func: this.cancelEditList
        }
      ],

      leadButton: [
        {
          label: "取消",
          type: "default",
          func: this.closeLeadDialog
        },
        {
          label: "确定",
          func: this.leadSure
        }
      ],


      advises: [],

      kinds:[],
      settingValues: [],

      tableData: [],
      treeData: [],
      selectCodeNode: '',



      app: "",

      treeDefaultParams
    };
  },

  mounted() {
    let me = this;
    me.headers.Authorization = token.getToken();
    me.layout = [
      [
        {
          span: 0,
          type: "menu",
          label: "数据字典",
          api: "data.listDict",
          defaultParams: {applicationId: this.appId},
          // singleSelect: true,
          columns: [
            { type: "selection" },
            { type: "index" },
            { prop: "active",
              label: "有效",
              width: 60,
              formatter: me.activeFormatter },
            { slot:{type:'href',func:me.edit},prop: "name", label: "数据名称",tooltip:true },
             { prop: "code", label: "编码",tooltip:true },
            { prop: "values", label: "选项值",tooltip:true},
            { prop: "codeContent", label: "设置选项值",tooltip:true,formatter:me.codeFormatter },
            {
              prop: "personal",
              label: "所属",
              formatter: me.belongsFormatter,
              tooltip: true
            },
            { prop: "remark", label: "备注",tooltip:true }
          ]
        },
        {
          span: 11,
          type: "button",
          items: [
            {
              label: "新建",
              icon: "fa fa-plus-square",
              func: me.addTitle
            },
            // {
            //   label: "编辑",
            //   icon: "fa fa-pencil fa-fw",
            //   func: me.edit
            // },
            {
              label: "删除",
              icon: "fa fa-trash-o fa-fw",
              func: me.deleteDict
            },
            {
              label: "复制",
              icon: "fa fa-paste",
              func: me.copy
            },
            {
              label: "批量修改分类",
              icon: "fa fa-pencil fa-fw",
              func: me.editCatalogList
            }
          ],suffixSlot:"more"
        }/*,
        {
          span: 1,
          type: "slot",
          name: 'more'
        }*/,
        {
          span: 6,
          type: "searchText",
          name: "name",
          offset: 7
        }
      ]
    ];
  },

  methods: {

    importSuccessFunc(response, file, fileList) {
      if (response && response.success) {
        this.mwMsg("导入成功");
        this.closeLeadDialog();
        this.mwRef("dictTree").refresh();
      } else {
        this.mwMsg('warning', response && response.msg || '导入失败');
      }
    },

    handleCommand(command){
       if(command === 'leadOut'){
          this.leadOut();
       }
       if(command === 'lead'){
          this.lead();
       }
       if(command === 'leadOldData'){
          this.leadOldData();
       }
       if(command === 'loadModules'){
          this.loadModules();
       }
       if(command === 'loadUpdateData'){
          this.loadUpdateData();
       }

    },


    // 导入
    lead() {
      this.showDialog("leadDialog");
    },
    closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },
    leadSure() {
      this.mwRef("importDict").submit();
    },

    // 导出
    async leadOut() {
      const data = this.mwRef('dataTable').getMultipleSelection();
      let params = '';
      if (data && data.length > 0) {
        params = {ids: data.map(x => x.id)};
      } else if (this.selectNode) {
        if (await this.mwConfirm("您未选择需要导出的数据，是否需要导出当前选中分类'" + this.selectNode + "'下所有的数据？")) {
          params = {categories: [this.selectNode]};
        }
      } else {
        this.mwMsg("info", "请选中导出的数据");
      }
      if (params) {
        const response = await this.mwUtil.downloadAttachment2({
          url: '/api/sys/exportDict',
          params: {
            jsonData: JSON.stringify(params),
            applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
          },
        });
        if (response.success) {
          this.mwMsg('导出成功');
        } else if (response.msg) {
          this.mwMsg('waring',  response.msg)
        }
      }
    },

    async exportAll() {
        const response = await this.mwUtil.downloadAttachment2({
          url: '/api/sys/exportDict',
          params: {
            jsonData: '',
            applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
          },
        });
        if (response.success) {
          this.mwMsg('导出成功');
        } else if (response.msg) {
          this.mwMsg('waring',  response.msg)
        }
    },

    // 导入旧数据
    leadOldData() {},
    // 加入模块
    loadModules() {},
    // 加入更新包
    loadUpdateData() {},

    deptChoose(data) {

      let unit = [];
      let unitIds = [];
      data.forEach(d => {
        unit.push(d.name);
        unitIds.push(d.id);
      });

      this.form.unitName = unit.join();
      this.form.unitId = unitIds.join();
    },

    showDataAddress() {
      this.moreSys = !this.moreSys;
    },

    addTitle() {
      this.mwRef("titleTree").show();
      this.addCode = true;
      this.form= {
        catalog: this.selectNode,
        name: "",
        active: "T",
        personal: "F",
        applicationId:'',
        atrrs: "S",
        types: "0",
        typeedit: 2,
        values: "",
        codeContent: '',
        remark: "",
        unitName: "",
        unitId: "",
        code: ''
      }
    },

    saveDict() {

      if (this.form.personal === "F") {
        this.clearDept();
      }
      if (this.form.types != "0") {
        this.form.value = this.form.codeContent;
        delete this.form.values;
      } else {
        delete this.form.codeContent;
        this.form.values = this.form.value;
      }
      this.mwRef("dataForm").validate(valid => {
        if (valid) {
           delete this.form.value;
           if (this.form.types != "0") {
              this.form.values = '';
           } else {
              this.form.codeContent ='';
           };
           if(this.shouldApplicationIdInRequest && !this.form.applicationId){
             this.form.applicationId=this.$route.params.appId
           }
          let me=this;

          this.mwApi.data.saveDict(this.form).then(res => {
            if (res.success) {
              this.mwMsg("info", "保存成功");
              this.mwRef("titleTree").hide();
              this.refreshTable();
              this.handleClose();
            }
          });
        }else{
          this.mwMsg("信息未填写完整");
        }
      });
    },

    loadTableTree(data) {
      this.selectNode = data.catalog || data.text;
      this.mwRef("dataTable").refreshTableDefaultParams({
        catalog: data.catalog || data.text,
        applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
      });
    },

    deleteDict(data) {
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要删除的数据");
      } else {
        let ids = [];
        data.forEach(d => {
          ids.push(d.id);
        });
        this.mwApi.data.deleteDict(ids, {applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined}).then(res => {
          if (res.success) {
            this.mwMsg("删除成功");
            this.refresh();
          } else {
            this.mwMsg("info", "删除失败");
          }
        });
      }
    },

    edit(row,index) {
        this.mwApi.data.getDict(row.id, {applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined}).then(res => {
          if (res.success) {
             this.form= {
              catalog: this.selectNode,
              name: "",
              active: "T",
              personal: "F",
              applicationId:'',
              atrrs: "S",
              types: "0",
              typeedit: 2,
              values: "",
              codeContent: '',
              remark: "",
              unitName: "",
              unitId: "",
              code: ''
            }
            this.addCode = false;
            this.mwUtil.applyCover(this.form, res.result);
            this.form.id = res.result.id;
            if (this.form.types === "0") {
              this.form.value = res.result.values;
            }
            this.showDialog("titleTree");
          }
        });

    },

    copy(data) {
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要复制的数据");
      } else {
        data.forEach(d => {
          delete d.id;
          d.name = d.name + "-副本";
          this.mwApi.data.saveDict(d).then(res => {
            if (res.success) {
              this.mwMsg("复制成功");
            }
          });
        });
        this.refreshTable();
      }
    },

    handleRadio() {
      if (this.types != "0") {
        this.mwRef("dataForm").clearValidate();
      }
    },

    handleClose() {
      this.resetFields();
      this.form.name = "";
      this.form.values = "";
      this.form.value = "";
      // this.form.catalogContent = "";
      this.form.codeContent = "";
      this.mwRef("titleTree").hide();
    },
    addSetting(){
       this.showDialog('setValuesDialog');
    },



   chooseSure() {
       let data =this.mwRef('valueChoose').getValue();
       this.form.codeContent =  JSON.stringify(data);
       this.mwRef("setValuesDialog").hide();
    },



    showDialog(a) {
      this.mwRef(a).show();
    },



    cancel() {
      this.mwRef("setValuesDialog").hide();
    },

    // 批量修改分类
    editCatalogList(data) {
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要操作的数据");
      } else {
        this.mwRef("editListDialog").show();
        this.tableData = data;
        this.catalog = this.selectNode;
      }
    },

    editListSure() {
      this.tableData.forEach(d => {
        d.catalog = this.catalog;
        this.mwApi.data.saveDict(d).then(res => {
          if (res.success) {
            this.mwMsg("修改成功");
            this.refresh();
            this.mwRef("editListDialog").hide();
          }
        });
      });
    },

    cancelEditList() {
      this.mwRef("editListDialog").hide();
    },

    getDept() {
      this.$prompt("编号值", "请填写编号值", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {})
        .catch(() => {});
    },

    closeDialog() {
      this.mwRef("dialog").hide();
    },

    belongsFormatter(data) {
      if (data.personal === "T") {
        return data.unitName;
      } else {
        return "公有";
      }
    },

    activeFormatter(data){
      if(data.active === 'T'){
         return (<i class="fa fa-check-square" style="color:#1ab394"></i>)
      }
    },

    codeFormatter(data){
      let res = [];
      if(data.types == '1' && data.codeContent && data.codeContent.length != 0){
        let json = JSON.parse(data.codeContent);
        json.forEach(d =>{
         if(d.data && d.data.length > 0){
           d.data.forEach(t =>{
             let a = d.name+ '/'+t.name;
              res.push(a);
            })
         }else{
             let a = d.name+ '/';
             res.push(a);
         }
       })
      }
      return res.join();
    },

    clearDept() {
      this.form.unit = "";
      this.form.unitName = "";
    },

    refreshTable(){
      this.mwRef("dataTable").refreshTableDefaultParams({
        catalog: this.selectNode,
        applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
      });
    },

    refresh() {
      this.mwApi.data.listDict({start: 0,limit:1,catalog:this.selectNode, applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined}).then(res =>{
        if( res.success){
          if(res.result && res.result.length === 1){
            this.mwRef("dataTable").refreshTableDefaultParams({
              catalog: this.selectNode,
              applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
            });
          }else{
            this.mwRef("dictTree").refresh();
            this.mwRef("dataTable").refreshTableDefaultParams({
              catalog: this.selectNode,
              applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined
            });
          }
        }
      })

    },

    resetFields() {
      this.mwRef("dataForm").resetFields();
    },
    expand() {
      this.mwRef("dictTree").openAll();
    },
    closed() {
      this.mwRef("dictTree").closeAll();
    }
  },
  watch: {

  }
};
</script>






// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/dataDic.vue